/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, BigNumberish } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { MockWETH } from '../MockWETH'

export class MockWETH__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(
    _name: string,
    _symbol: string,
    _decimals: BigNumberish,
    overrides?: Overrides
  ): Promise<MockWETH> {
    return super.deploy(
      _name,
      _symbol,
      _decimals,
      overrides || {}
    ) as Promise<MockWETH>
  }
  getDeployTransaction(
    _name: string,
    _symbol: string,
    _decimals: BigNumberish,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _name,
      _symbol,
      _decimals,
      overrides || {}
    )
  }
  attach(address: string): MockWETH {
    return super.attach(address) as MockWETH
  }
  connect(signer: Signer): MockWETH__factory {
    return super.connect(signer) as MockWETH__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): MockWETH {
    return new Contract(address, _abi, signerOrProvider) as MockWETH
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: '_name',
        type: 'string'
      },
      {
        internalType: 'string',
        name: '_symbol',
        type: 'string'
      },
      {
        internalType: 'uint8',
        name: '_decimals',
        type: 'uint8'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Approval',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'Transfer',
    type: 'event'
  },
  {
    stateMutability: 'payable',
    type: 'fallback'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      }
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256'
      }
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'deposit',
    outputs: [],
    stateMutability: 'payable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256'
      }
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'mint',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'sender',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'recipient',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      }
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    stateMutability: 'payable',
    type: 'receive'
  }
]

const _bytecode =
  '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'
